import { memo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Button, Tooltip } from "@mui/material";
// cmps
import Code from "../../code";
// types
import type { SxProps, Theme } from "@mui/material";

const SC = { strong: <strong />, code: <code /> };
const SCI = { strong: <strong />, code: <code />, i: <i /> };

const BUTTON_SX = {
	cursor: "help",
	textTransform: "none",
} as const satisfies SxProps<Theme>;

const TOOLTIP_SX = {
	maxWidth: 480,
	p: "12px 14px",
	bgcolor: "rgba(30, 30, 30, 0.96)",
	color: "#fff",
	fontSize: 12,
} as const satisfies SxProps<Theme>;

const SpecContent = () => {
	const { t } = useTranslation();

	return (
		<div>
			<div style={{ fontWeight: "bold", marginBottom: 6 }}>
				{t("gateway.networkMap.diagnostics.spec.originHeading")}
			</div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.directRouterEntry" components={{ strong: <strong /> }} /></div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.neighborTableEntry" components={SC} /></div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.childTableEntry" components={SC} /></div>
			<div style={{ fontWeight: "bold", marginTop: 10, marginBottom: 6 }}>
				{t("gateway.networkMap.diagnostics.spec.fieldsHeading")}
			</div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.relationshipEntry" components={{ strong: <strong /> }} /></div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.lqiEntry" components={{ strong: <strong /> }} /></div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.connectionTimeEntry" components={{ strong: <strong /> }} /></div>
			<div style={{ fontStyle: "italic", paddingLeft: 10 }}>
				<Trans i18nKey="gateway.networkMap.diagnostics.spec.ageQuoteEntry" components={{ code: <code /> }} />
			</div>
			<div style={{ paddingLeft: 10, marginTop: 2 }}>
				<Trans i18nKey="gateway.networkMap.diagnostics.spec.ageNoteEntry" components={{ code: <code /> }} />
			</div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.connectionTimeRemainingEntry" components={{ strong: <strong /> }} /></div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.configuredTimeoutEntry" components={SC} /></div>
			<div style={{ paddingLeft: 10 }}>
				<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.encodingEntry" components={SC} /></div>
				<Code code={t("gateway.networkMap.diagnostics.spec.encodingTable")} />
				<div style={{ marginTop: 4 }}>
					<Trans i18nKey="gateway.networkMap.diagnostics.spec.useEntry" components={SCI} />
				</div>
				<div style={{ marginTop: 4 }}>
					<Trans i18nKey="gateway.networkMap.diagnostics.spec.practicalEntry" components={{ strong: <strong /> }} />
				</div>
				<div style={{ marginTop: 4 }}>
					<Trans i18nKey="gateway.networkMap.diagnostics.spec.ageVsTimeoutEntry" components={SC} />
				</div>
			</div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.inCostEntry" components={{ strong: <strong /> }} /></div>
			<div style={{ fontStyle: "italic", paddingLeft: 10 }}>
				<Trans i18nKey="gateway.networkMap.diagnostics.spec.inCostQuoteEntry" components={{ code: <code /> }} />
			</div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.outCostEntry" components={{ strong: <strong /> }} /></div>
			<div style={{ fontStyle: "italic", paddingLeft: 10 }}>
				<Trans i18nKey="gateway.networkMap.diagnostics.spec.outCostQuoteEntry" components={{ code: <code /> }} />
			</div>
			<div style={{ paddingLeft: 10, marginTop: 2 }}>
				<Trans i18nKey="gateway.networkMap.diagnostics.spec.costSevenEntry" components={{ strong: <strong /> }} />
			</div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.txPowerEntry" components={SC} /></div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.phyEntry" components={{ strong: <strong /> }} /></div>
			<div style={{ fontWeight: "bold", marginTop: 10, marginBottom: 6 }}>
				{t("gateway.networkMap.diagnostics.spec.lineStylesHeading")}
			</div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.solidEntry" components={{ strong: <strong /> }} /></div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.dashedEntry" components={{ strong: <strong /> }} /></div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.dottedEntry" components={{ strong: <strong /> }} /></div>
			<div style={{ fontWeight: "bold", marginTop: 10, marginBottom: 6 }}>
				{t("gateway.networkMap.diagnostics.spec.notesHeading")}
			</div>
			<div><Trans i18nKey="gateway.networkMap.diagnostics.spec.notesEntry" components={SC} /></div>
		</div>
	);
};

const NetworkMapSpecification = () => {
	const { t } = useTranslation();

	return (
		<div style={{ position: "absolute", top: 12, right: 12, zIndex: 12 }}>
			<Tooltip
				title={<SpecContent />}
				placement="bottom-end"
				slotProps={{ tooltip: { sx: TOOLTIP_SX } }}
			>
				<Button variant="outlined" size="small" sx={BUTTON_SX}>
					{t("gateway.networkMap.diagnostics.specification")}
				</Button>
			</Tooltip>
		</div>
	);
};

export default memo(NetworkMapSpecification);
